import { Component, computed, EventEmitter, inject, input, Output } from "@angular/core";
import { FilterOverview } from "src/models/shared/filter.model";
import { FavoriteListStates, OverviewFavoriteListsStore } from "src/stores/overview-favorite-lists.store";
import { MAX_UNITS_IN_LIST, SelectedFavoriteListsStore } from "src/stores/selected-favorite-list.store";

@Component({
    selector: "favorite-list-menu",
    templateUrl: "./favorite-list-menu.component.html",
    styleUrl: "./favorite-list-menu.component.scss",
})
export class FavoriteListMenuComponent {
    selectedId = input<number>();
    @Output() onOpen: EventEmitter<number> = new EventEmitter<number>();
    @Output() onRename: EventEmitter<number> = new EventEmitter<number>();
    @Output() onDelete: EventEmitter<number> = new EventEmitter<number>();
    @Output() onClose: EventEmitter<number> = new EventEmitter<number>();
    @Output() onExportSelectionToExcel: EventEmitter<FilterOverview> = new EventEmitter<FilterOverview>();
    @Output() onExportSelectionToPdf: EventEmitter<FilterOverview> = new EventEmitter<FilterOverview>();
    @Output() onGotoListMapBounds: EventEmitter<number> = new EventEmitter<number>();
    @Output() onAddAllSelection: EventEmitter<number> = new EventEmitter<number>();
    @Output() onRemoveAllSelection: EventEmitter<number> = new EventEmitter<number>();

    readonly overviewStore = inject(OverviewFavoriteListsStore);
    readonly selectedFavoriteListStore = inject(SelectedFavoriteListsStore);

    overview = computed(() => this.overviewStore.overview().filter((overview) => overview.id === this.selectedId())[0]);
    currentState = computed(() => this.overviewStore.state());
    showMenu = computed(() => this.overviewStore.activeMenu() === this.selectedId());

    FavoriteListStates = FavoriteListStates;

    hasAreaFilter = computed(() => this.currentState() == FavoriteListStates.Overview ? this.overview()?.hasAreaFilter : this.selectedFavoriteListStore.areas()?.length > 0);
    hasUnitFilter = computed(() => this.currentState() == FavoriteListStates.Overview ? this.overview()?.hasUnitFilter : this.selectedFavoriteListStore.units()?.length > 0);
    tooManyUnits = computed(() =>
        this.currentState() == FavoriteListStates.Overview ? this.overview()?.numberOfUnits > MAX_UNITS_IN_LIST : this.selectedFavoriteListStore.tooManyUnits()
    );
    canExport = computed(() => this.hasUnitFilter() && !this.tooManyUnits());

    zoomToArea(event: any) {
        event.stopPropagation();
        if (this.hasAreaFilter() || this.hasUnitFilter()) {
            this.onGotoListMapBounds.emit(this.selectedId());
        }
    }
    exportSelectionToPdf(event: any) {
        event.stopPropagation();
        if (this.canExport()) {
            this.onExportSelectionToPdf.emit(this.overview());
        }
    }
    exportSelectionToExcel(event: any) {
        event.stopPropagation();
        if (this.canExport()) {
            this.onExportSelectionToExcel.emit(this.overview());
        }
    }
}
